import React from "react";
// import bg from "../../../assets/images/aptech-assessment-and-testing-solutions-bg.png";
import styles from "./BannerComponent.module.scss";

export default function BannerComponent({
  title1,
  title2,
  bg,
}: {
  title1: string;
  title2?: string;
  bg: any;
}) {
  return (
    <div
      style={{
        width: "100%",
        height: "450px",
        backgroundImage: `url(${bg})`,
        borderRadius: "20px",
      }}
      className="d-flex flex-row justify-content-center align-items-center"
    >
      <div className={styles.bannerTxtContainer}>
        <p style={{ color: "#FFF", textAlign: "center" }} className="heading">
          {title1}
        </p>
        {title2 && (
          <p className="para" style={{ color: "#FFF", textAlign: "center" }}>
            {title2}
          </p>
        )}
      </div>
    </div>
  );
}
